import { render, staticRenderFns } from "./SimulatorShipPicker.vue?vue&type=template&id=4bf12686&scoped=true&"
import script from "./SimulatorShipPicker.vue?vue&type=script&lang=js&"
export * from "./SimulatorShipPicker.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorShipPicker.vue?vue&type=style&index=0&id=4bf12686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf12686",
  null
  
)

export default component.exports